import { Action, Reducer } from 'redux';
import {
  BodyshopBranchState,
  BodyshopBranchTypes,
  BodyshopBranchActionTypes
} from './bodyshopBranchTypes';

export const INITIAL_STATE: BodyshopBranchState = {
  bodyshopBranches: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  }
};

const bodyshopBranchReducer: Reducer<BodyshopBranchState> = (
  state: BodyshopBranchState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as BodyshopBranchActionTypes;
  switch (actionTypes.type) {
    case BodyshopBranchTypes.GET_BODYSHOP_BRANCHES:
      return {
        ...state,
        bodyshopBranches: { ...state.bodyshopBranches, isLoading: true }
      };
    case BodyshopBranchTypes.SAVE_BODYSHOP_BRANCHES:
      return {
        ...state,
        bodyshopBranches: {
          ...state.bodyshopBranches,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case BodyshopBranchTypes.RESET_REDUCER_BODYSHOP_BRANCHES:
      return {
        ...state,
        bodyshopBranches: INITIAL_STATE.bodyshopBranches
      };
    default:
      return state;
  }
};

export default bodyshopBranchReducer;
